<template>
  <div
    class="z-60 cover relative flex h-screen flex-col items-center justify-center gap-10"
    style="z-index: 99999999"
  >
    <div class="flex flex-col items-center">
      <h1 class="text-6xl font-extrabold">OOOPS!!!</h1>
      <span class="text-9xl font-extrabold text-[var(--p-primary-color)]">500</span>
      <span class="text-5xl font-extrabold">INTERNAL SERVER ERROR</span>
    </div>
    <div
      class="flex cursor-pointer items-center gap-4 text-2xl font-bold transition-colors hover:text-[var(--p-primary-color)]"
    >
      <span @click="$router.go(-1)">Voltar</span>
    </div>
    <img class="absolute left-10 top-10" src="../../assets/logo-nepen.png" alt="" />
  </div>
</template>

<style scoped lang="scss">
.cover:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  inset: 0;
  opacity: 0.15;
  z-index: -1;
  background: url(../../assets/meter.svg);
  background-repeat: repeat;
}
</style>
